import { IconButton } from '../../../button/icon-button.js';
import { Text } from '../../../typography/text.js';
import { useViewHeader } from '../use-view-header.js';
import { ViewGrid } from '../view-grid.js';
import { useMultiYearViewState } from './use-multi-year-view-state.js';

/** @internal */
export function MultiYearView() {
  const state = useMultiYearViewState();
  const { nextButtonProps, prevButtonProps } = useViewHeader(state);

  return (
    <>
      <div className="cim-date-picker-view-header">
        <IconButton slot={null} {...prevButtonProps} />

        <Text as="span" variant="title-6" tone="base">
          {state.header}
        </Text>

        <IconButton slot={null} {...nextButtonProps} />
      </div>

      <ViewGrid state={state} className="cim-date-picker-view-grid-multi-year" />
    </>
  );
}
